import { FrontendRoutes } from './Constants/Navigation';
import { DuplicateValidationFormMap } from './Models';

export const S3Assets = {
  errorWarning:
    'https://wildgamebutcher-dev.s3.us-east-1.amazonaws.com/frontend-assets/ErrorWarning.png',
  successCheck:
    'https://wildgamebutcher-dev.s3.us-east-1.amazonaws.com/frontend-assets/SuccessImg.png',
};

export const timers = {
  TOAST_AUTO_CLOSE: 5000,
};

export const countryCode = {
  US: 636,
};

export const quantityCount = {
  decrement: -1,
  increment: 1,
};

export const httpStatusCodes = {
  BAD_REQUEST_400: 400,
  BAD_REQUEST_409: 409,
  UNAUTHORIZED_401: 401,
  SUCCESS_201: 201,
  SUCCESS_200: 200,
  INTERNAL_SERVER_ERROR_500: 500,
};

export const fieldAttributes = {
  PASSWORD_MIN_LENGTH: 8,
  DESCRIPTION_LIMIT: 150,
};

export const fileUploadConfig = {
  MAX_FILE_SIZE: 2097152, // 2MB
  ALLOWED_FILE_FORMATS: ['image/jpeg', 'image/png'],
  INITIAL_PROGRESS: 0,
  BYTES_CONVERSION: 1024,
  THRESHOLD_PERCENTAGE: 100,
  UPDATE_INTERVAL_MS: 300,
  PROGRESS_INCREMENT: 10,
  NETWORK_DELAY_MS: 3000,
};

export const searchConfig = {
  SEARCH_DELAY: 800,
};

export const formRegex = {
  EMOJI: /^[a-zA-Z0-9\s.,'-]*$/,
  HTMLTags: /^[^<>]*$/,
  PRICE: /\d+(\.\d{1,2})?/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MOBILE_NUMBER: /^\d{10}$/,
  PASSWORD:
    /^(?=.*[A-Z])(?=.*[a-zA-Z\d])(?=.*[!@#$%^&*(),.?":{}|<>[\]\\/\-_+`~])[A-Za-z\d!@#$%^&*(),.?":{}|<>[\]\\/\-_+`~]{8,}$/,
  INVALID_CHAR: /[^a-zA-Z\s]/,
  NUMBERS: /^\d*$/,
  SPECIAL_CHARACTERS: /[!@#$%^&*(),.?":{}|<>[\]\\/\-_+`~]/,
  POSTALCODE: /^\d{5}$/,
  ALPHABETS_AND_NUMBERS_AND_SPECIAL_CHARACTERS:
    /^[a-zA-Z0-9!@#$%^&*(),.?":{}|<>[\]\\/\-_+`~]*$/,
  DECIMAL_UP_TO_TWO_PLACES: /^\d*\.?\d{0,2}$/,
  ALPHANUMERIC: /^[A-Za-z0-9 ]+$/,
};

export const errorMessage = {
  FIELD_REQUIRED: 'This field is required.',
  INVALID_CONTACT_NUMBER: 'Enter a valid 10-digit phone number.',
  INVALID_EMAIL: 'Enter a valid email address.',
  INVALID_PASSWORD:
    'Password must have a minimum of 8 characters with at least one uppercase letter and one special character. Special characters allowed: !@#$%^&*(),.?\\":{}|<>[\\]/-_+`~',
  PASSWORD_MATCH_FAILED: 'Passwords do not match.',
  INVALID_CHARACTERS: 'Special characters or emojis are not allowed.',
  INVALID_HTML_TAGS: 'HTML tags are not allowed.',
  INVALID_FORM: 'Please submit the form with the valid data.',
  NETWORK_ERROR: 'A network error occurred. Please try again.',
  DEFAULT_ERROR_MESSAGE: 'An error occurred. Please try again.',
  UNEXPECTED_ERROR: 'Unexpected error occurred. Please try again.',
  SERVER_ERROR: 'Unable to connect to the server. Please try again later.',
  FETCH_ERROR: 'Error fetching the data. Please try again.',
  EMPTY_FORM_SUBMISSION: 'Please fill in at least one field.',
  MAX_FILE_SIZE_ERROR: 'File size exceeds 2 MB. Please select a smaller file.',
  FILE_FORMATS: 'Only .jpg and .png files are allowed.',
  FILE_SELECTION_ERROR: 'Error selecting file. Please try again.',
  AUTHENTICATION_ERROR:
    'An error occurred during authentication. Please log in again.',
  PRICE_NUMERIC_ERROR: 'Invalid Price.',
  DUPLICATE_ERROR: 'Duplicate entries are not allowed.',
  NAME_ERROR: 'Name should not contain numbers.',
  SPECIAL_CHARACTERS: 'Special characters are not allowed.',
  REGISTER_FAILED: 'Registration is not done. Please try again.',
  TERMS_AND_CONDITION_FAILURE:
    'Please accept the Terms and Conditions to proceed.',
  INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password.',
  UPLOAD_REQUIRED: 'Please complete the upload before proceeding.',
  UPLOAD_FAILED: 'Failed to save progress. Please try again.',
  INVALID_POSTALCODE: 'Postal code must be 5 digits.',
  SUBMIT_FAILED: 'Address is not Saved. Please try again.',
  EMPTY_FIELD_ERROR: 'Please add at least one service before proceeding.',
  DUPLICATE_SERVICE: 'Service already exists.',
  DESCRIPTION_EXEEDS_150_CHARECTER: 'Description exceeds 150 characters.',
  FAILED_TO_SAVE_SERVICE: 'Failed to save services. Please try again.',
  PATCH_CONNECTION_ERROR:
    'An error occurred while fetching fee types. Please check your connection and try again.',
  FORGOT_PASSWORD_FAILURE:
    'Failed to send the request. Please try again later.',
  INVALID_TOKEN: 'Invalid or expired token. Please try again.',
  PRODUCT_EXISTS: 'This product already exists.',
  MINTYPE_ADD_FAILURE: 'Request failed. Please try again.',
  INVALID_COLOR: 'Color name cannot contain numbers or special characters.',
  COLOR_EXISTS: 'Color already exists.',
  FEETYPE_DUPLICATE_ERROR: 'This combination already exists.',
  ALL_REQUIRED: 'All fields are required.',
  VALID_NUMBERS: 'Field must contain valid numbers.',
  PACKAGESIZE_ERROR: 'Package size must be a number.',
  PRICE_ERROR: 'Price must be a number.',
  ERROR_CREATING_ROLE: 'Failed to create the role. Please try again.',
  ERROR_FETCHING_ROLE: 'Failed to fetch roles. Please try again.',
  ERROR_FETCHING_MODULES: 'Failed to fetch modules. Please try again.',
  ERROR_UPDATING_ROLE: 'Failed to update the role. Please try again.',
  ERROR_DELETING_USER: 'Failed to delete the user. Please try again.',
  ERROR_CREATING_OPERATION: 'Failed to create the operation. Please try again.',
  ERROR_UPDATING_OPERATION: 'Failed to update the operation. Please try again.',
  FORM_REQUIRED: 'Fill out the required fields before proceeding.',
  DELETE_FAILED: 'Failed to delete the record. Please try again.',
  DELETE_SUCCESS: 'Record deleted successfully.',
  ERROR_FETCHING_SERVICES: 'Failed to fetch services. Please try again.',
  ERROR_FETCHING_FEETYPES: 'Failed to fetch fee types. Please try again.',
  ERROR_FETCHING_SPECIES_AND_SERVICE:
    'Failed to fetch services rate. Please try again.',
  SPECIES_SELECTION: 'Species selection failed.',
  INVALID_CHAR_ERROR: 'Enter a valid name without special characters.',
  ALPHANUMERIC_ERROR: 'Only alphanumeric characters are allowed.',
  DUPLICATE_PACKAGE_ERROR:
    'This package type with the same size already exists.',
  DUPLICATE_SIZE_ERROR: 'The entered size already exits.',
  INVALID_PACKAGE_SIZE: 'Package size should be in number.',
  NOTES_EXEEDS_200_CHARECTER: 'Notes must be under 200 characters',
  LICENSE_VERIFICATION_FAILURE:
    'Error verifying license. Please check the species license for this state.',
  SPECIES_SELECTION_VALIDATION_ERROR:
    'Please select at least one species before proceeding.',
  SPECIES_SELECTION_QUANTITY_ERROR: 'Please select at least one quantity.',
  ERROR_FETCHING_CUSTOMERS: 'Failed to fetch customers. Please try again.',
  ERROR_UPDATING_CUSTOMER: 'Failed to update the customer. Please try again.',
  LICENSE_VALIDATION_FAILURE: 'Please fill all license fields before saving.',
  CUSTOMER_VALIDATION_FAILURE: 'Please fill in all required customer details.',
  INVALID_CITY: 'City name cannot contain numbers or special characters.',
  NEW_LICENSE_CREATION_FAILURE:
    'Please fill the existing license before adding a new one',
  INVALID_CUSTOMER_DATA: 'Invalid customer data received.',
  ORDER_SPECIES_CUSTOMIZATION_FAILURE:
    'Please finish all species customizations steps before proceeding.',
  ERROR_CREATING_ORDER: 'Failed to create the order. Please try again.',
  ORDER_SERVICE_REQUIRED: 'Please select at least one service.',
  ORDER_PACKAGE_REQUIRED: 'Please add packaging for all products.',
  ORDER_PACKAGE_PERCENTAGE_INVALID: 'Packaging split percentage should be 100%',
  ORDER_PACKAGING_PERCENTAGE_INVALID:
    'The total packaging percentage for each product must add up to 100%.',
  ORDER_PRODUCT_REQUIRED: 'Please select at least one product.',
  ORDER_DUPLICATE_PACKAGE: 'This package is already selected for this product.',
  INVALID_ORDER_DATA: 'Invalid order data received.',
  ERROR_UPDATING_SERVICE_WORKFLOW:
    'Error updating the service workflow. Please try again.',
  NO_NOTES_FOUND: 'No notes were added.',
  DATA_ALREADY_EXISTS: 'Entered data already exists.',
  PRODUCT_NAME_REQUIRED: 'Name is required.',
  PRODUCT_PRICE_REQUIRED: 'Price must be greater than 0',
  PRODUCT_TYPE_ONE_WEIGHT_INVALID: 'Weight should be at least 0 lb.',
  PRODUCT_MINQUANTITY_REQUIRED: 'Minimum Quantity is required',
  PRODUCT_MINTYPE_REQUIRED: 'Minimum Type is required',
  PRODUCT_WEIGHT_REQUIRED: 'Weight must be greater than 0',
  PRODUCT_MINQUANTITY_REQUIREMENT: 'Minimum quantity should be atleast',
  PRODUCT_WEIGHT_REQUIREMENT: 'Minimum weight should be atleast',
  PRODUCT_LIST_EMPTY: 'Atleast add one product to the list.',
  ORDER_ESTIMATION_DATE_REQUIRED:
    'Please enter the estimated completion date of the order.',
  ERROR_CREATING_USER: 'Failed to create the user. Please try again.',
  USER_ALREADY_EXISTS: 'User already exists.',
  ORDER_INCOMPLETION_ERROR:
    'Please complete all of the species details before viewing the order summary.',
  INVALID_REQUEST: 'Invalid request. Please try again.',
  ERROR_UPDATING_PRODUCT_WORKFLOW:
    'Error updating the product workflow. Please try again.',
  ORDER_PACKAGE_PERCENTAGE_SPLIT_ERROR:
    'The sum of the package spilt percentage should be 100.',
  FINAL_PACKAGE_REQUIRED:
    'Please select and set the percentage for at least one final package.',
  ORDER_PACKAGE_COUNT_ERROR: 'At least one packaging option must remain.',
  ORDER_PACKAGE_PERCENTAGE_ZERO_ERROR:
    'Packing percent cannot be 0. Please remove if not needed.',
  NOTES_SAVE_ERROR: 'Failed to save note',
  ERROR_GENERATING_INVOICE: 'Failed to generate invoice. Please try again.',
  ERROR_FREE_STORAGE_LESS_THAN_NOTIFICATION:
    'Free Storage Days must be greater than Number of Days to Notify.',
  ERROR_RESETTING_DEFAULTS: 'Failed to reset to defaults. Please try again.',
  ERROR_DELETING_OPERATION: 'Failed to delete the operation. Please try again.',
  FEETYPE_UNIT_ERROR: 'Fee type unit should not contain numbers.',
  SERVICE_COLOR_REQUIRED: 'Color is required for one of the selected services.',
  INVALID_TAX: 'Tax should not be negative value',
  ERROR_CREATING_ADDRESS: 'Error creating address. Please try again.',
  ERROR_DELETING_ROLE: 'Error deleting role.',
  ERROR_ADDING_CUSTOMER_LICENSE:
    'Please fill the current license details before adding a new one.',
  LATE_FOR_PICKUP_CHARGES_REQUIRED:
    "Please fill out the 'Late Pick-up' fields.",
  REQUIRED_ERROR: 'Add at least one record before proceeding.',
  ERROR_DOWNLOADING_PDF: 'Failed to download PDF. Please try again.',
  INVOICE_NOT_FOUND: 'No invoice selected for PDF download',
  ORDER_NOT_FOUND: 'No order selected for PDF download',
  PRODUCT_FINAL_WEIGHT_REQUIRED:
    'Please enter the final weight of the product.',
  LICENSE_VALIDATION_ERROR:
    'Please save the current license before adding a new one.',
  LICENSE_SAVE_FAILURE: 'Error saving license',
  CHECKIN_REQUIRED: 'Please fill in the check-in details.',
  INVALID_PROMOCODE: 'Invalid Promo code.',
  ERROR_CANCELLING_SUBSCRIPTION:
    'Failed to cancel subscription. Please try again.',
  REQUIRED_CAPTCHA: 'Please complete the reCAPTCHA verification.',
  SUBSCRIPTION_INACTIVE_ADMIN_ERROR: 'Please subscribe to a plan to continue.',
  SUBSCRIPTION_INACTIVE_NON_ADMIN_ERROR:
    'An active plan is required. Please contact your admin.',
};

export const responseTexts = {
  UPLOAD_SUCCESS: 'File uploaded successfully.',
  PDF_DOWNLOAD_SUCCESS: 'PDF downloaded successfully',
  ADDRESS_ADD_SUCCESS: 'Address created successfully',
  SPECIES_UPDATE_SUCCESS: 'Species updated successfully.',
  SPECIES_ADD_SUCCESS: 'Species created successfully.',
  REGISTER_SUCCESSFUL: 'Successfully registered.',
  RESET_EMAIL_SENT: 'Password resetting link has been sent to your email.',
  RESET_PASSWORD_SUCCESS:
    'Password has been reset successfully. Redirecting to the login page now.',
  ROLE_CREATED: 'Role created/updated successfully.',
  ROLE_FETCH_SUCCESS: 'Roles fetched successfully.',
  ROLE_UPDATE_SUCCESS: 'Role updated successfully.',
  OPERATION_CREATE_SUCCESS: 'Operation created successfully.',
  OPERATION_UPDATE_SUCCESS: 'Operation updated successfully.',
  USER_CREATION_SUCCESS: 'User created successfully.',
  USER_UPSERT_SUCCESS: 'User created/updated successfully.',
  ROLE_UPSERT_SUCCESS: 'Role created/updated successfully.',
  ADDON_REMOVE_SUCCESS: 'Chosen add-on removed successfully',
  ADDON_UPSERT_SUCCESS: 'Add-on created/updated successfully.',
  PACKAGE_SIZE_CREATION_SUCCESS: 'Package size created successfully.',
  LICENSE_VERIFICATION_SUCCESS: 'License verification successful',
  CUSTOMER_CREATION_SUCCESS: 'Customer saved successfully.',
  LICENSE_CREATION_SUCCESS: 'Customer license details saved successfully.',
  ORDER_CREATE_SUCCESS: 'Order created successfully',
  SERVICE_WORKFLOW_START_SUCCESS: 'Service process started successfully.',
  SERVICE_WORKFLOW_FINISH_SUCCESS: 'Service process finished successfully.',
  PRODUCT_UPDATE_SUCCESS: 'Product updated successfully.',
  PRODUCT_DELETE_SUCCESS: 'Product deleted successfully.',
  MINTYPE_CREATE_SUCCESS: 'Min Type added successfully.',
  MINQUANTITY_CREATE_SUCCESS: 'Min Quantity added successfully.',
  ADDRESS_CREATE_SUCCESS: 'Addresses added successfully.',
  SERVICE_CREATE_SUCCESS: 'Services added successfully.',
  PRODUCT_CREATE_SUCCESS: 'Product added successfully.',
  PACKAGE_CREATE_SUCCESS: 'Packages added successfully.',
  PACKAGE_TYPE_UPSERT_SUCCESS: 'Package type created/updated successfully.',
  PACKAGE_TYPE_DELETE_SUCCESS: 'Package type deleted successfully.',
  PRODUCT_WORKFLOW_START_SUCCESS: 'Product process started successfully.',
  PRODUCT_WORKFLOW_FINISH_SUCCESS: 'Product process finished successfully.',
  NOTES_UPDATE_SUCCESS: 'Note updated successfully',
  NOTES_ADDED_SUCCESS: 'Note added successfully',
  CHANGE_PASSWORD_SUCCESS: 'Password changed successfully.',
  OPERATIONS_SAVE_SUCCESS: 'Operation settings saved successfully.',
  ROLE_DELETION_SUCCESS: 'Role deleted successfully.',
  ROLE_DELETION_RESTRICTED:
    'Role Cannot be deleted. This role is assigned to an user. Remove it and try deleting it again.',
  COMPLETE_LOGO_STEP:
    'Please complete the logo upload step to access profile details.',
  COMPLETE_ADDRESS_STEP:
    'Please complete the address setup step to access profile details.',
  ORDER_SERVICE_SELECTION_WARNING:
    'Are you sure you want to proceed with no service selected?',
  NOTES_DELETE_CONFIRMATION:
    'Are you sure you want to delete these notes? This action is permanent and cannot be undone.',
  CHANGES_SAVE_SUCCESS: 'Changes saved successfully',
  LICENSE_CREATE_SUCCESS: 'License saved successfully',
  REDIRECTING_PAYMENT: 'Redirecting to payment page.',
  REPEAT_SPECIES_CONFIGURATION_SUCCESS:
    'Selected species configuration applied successfully.',
  PRODUCT_DUPLICATE_SUCCESS: 'Product duplicated successfully.',
};

export const productSubsteps = [
  { name: 'Products', step: 1, path: FrontendRoutes.PRODUCTS },
  { name: 'Add-on', step: 2, path: FrontendRoutes.ADDONS },
  { name: 'Packaging Type', step: 3, path: FrontendRoutes.PACKAGING_TYPE },
  { name: 'Pick Up', step: 4, path: FrontendRoutes.STORAGE_COST },
];

export const ManagementSubsteps = [
  { name: 'Role Management', step: 1, path: FrontendRoutes.ROLE_MANAGEMENT },
  { name: 'User Management', step: 2, path: FrontendRoutes.USER_MANAGEMENT },
];

export const speciesSubsteps = [
  { name: 'Species', step: 1, path: FrontendRoutes.SPECIES },
  { name: 'Service', step: 2, path: FrontendRoutes.SERVICES },
  { name: 'Color', step: 3, path: FrontendRoutes.COLOR },
  {
    name: 'Species & Service',
    step: 4,
    path: FrontendRoutes.SPECIES_AND_SERVICE,
  },
];

export const OperationSubsteps = [
  {
    name: 'Operation Management',
    step: 1,
    path: FrontendRoutes.OPERATION_MANAGEMENT,
  },
];

export const storeSetupSubsteps = [
  {
    name: 'Logo',
    step: 1,
    path: FrontendRoutes.LOGO,
  },
  {
    name: 'Address',
    step: 2,
    path: FrontendRoutes.ADDRESS,
  },
  {
    name: 'Tax',
    step: 3,
    path: FrontendRoutes.TAX_DETAILS,
  },
];

export const speciesBreadCrumbs = [
  { name: 'Store', stepId: 1 },
  { name: 'Species', stepId: 2 },
  { name: 'Products', stepId: 3 },
  { name: 'Roles and users', stepId: 4 },
  { name: 'Operations', stepId: 5 },
];

export const storeBreadcrumbs = [
  { name: 'Store', stepId: 1 },
  { name: 'Roles and users', stepId: 2 },
  { name: 'Operations', stepId: 3 },
];
export const storeSettingsSubsteps = [
  {
    name: 'Logo',
    step: 1,
    path: FrontendRoutes.STORE_LOGO,
  },
  {
    name: 'Address',
    step: 2,
    path: FrontendRoutes.STORE_ADDRESS,
  },
  {
    name: 'Tax',
    step: 3,
    path: FrontendRoutes.STORE_TAX,
  },
];
export const storeSpeciesAndProductBreadcrumbs = [
  { name: 'Species', stepId: 1 },
  { name: 'Products', stepId: 2 },
];
export const speciesSelectionSubsteps = [
  { name: 'species', step: 1, path: FrontendRoutes.SPECIES },
  { name: '', step: 2, path: FrontendRoutes.SPECIES },
  { name: '', step: 3, path: FrontendRoutes.SPECIES },
  { name: '', step: 4, path: FrontendRoutes.SPECIES },
  { name: '', step: 5, path: FrontendRoutes.SPECIES },
  { name: '', step: 6, path: FrontendRoutes.SPECIES },
  { name: '', step: 7, path: FrontendRoutes.SPECIES },
];

// export const permissions = ['read', 'write', 'edit', 'delete'];
//Please don't remove the commented code below. It will be used for future reference if needed.
// export const permissions = ['read', 'write', 'edit', 'delete'];
export const permissions = ['all'];

export const pagination = {
  itemsPerPage: 10,
  defaultPage: 1,
};

export const toastMessage = {
  delteConfirmation: `This action will remove all selected items. 
  You can still view them in the archives.\nAre you sure you want to remove?`,
  discardConfirmation: `Are you sure you want to discard changes?`,
};

export const orderBreadCrumbSteps = [
  'Customers',
  'customer_name',
  'New Order',
  'Order Summary',
];
export const CustomerDetailsCrumbSteps = [
  'Customers',
  'customer_name',
  'Details',
  'Order History',
];
export const SettignsCrumbSteps = [
  {
    name: 'My Store Settings',
    step: 1,
    path: '',
  },
];
export const SpeciesAndProductSetupCrumbSteps = [
  {
    name: 'Species & Product Set Up',
    step: 1,
    path: '',
  },
];

export const ExistingCustomerCrumbSteps = [
  {
    name: 'All Orders',
    step: 1,
    path: FrontendRoutes.ALL_ORDER_LIST,
  },
  {
    name: 'Existing Customers',
    step: 2,
    path: FrontendRoutes.CUSTOMER_LIST,
  },
];

export const AddNewCustomerCrumbSteps = [
  {
    name: 'All Orders',
    step: 1,
    path: FrontendRoutes.ALL_ORDER_LIST,
  },
  {
    name: 'Add New Customer',
    step: 2,
    path: FrontendRoutes.CREATE_CUSTOMER,
  },
];

export const AllOrderCrumbSteps = [
  {
    name: 'All Orders',
    step: 1,
    path: FrontendRoutes.ALL_ORDER_LIST,
  },
  {
    name: 'Order No.',
    step: 2,
    path: FrontendRoutes.ORDER_DETAILS,
  },
];
export const ServiceProcessingCrumbSteps = [
  {
    name: 'Service Processing',
    step: 1,
    path: FrontendRoutes.SERVICE_PROCESSING_LIST,
  },
  {
    name: 'Service Processing -',
    step: 2,
    path: FrontendRoutes.SERVICE_PROCESS_TASK_LIST,
  },
  {
    name: 'species_name',
    step: 3,
    path: FrontendRoutes.SERVICE_PROCESS_TASK_DETAILS,
  },
  {
    name: 'processItem_name',
    step: 4,
    path: FrontendRoutes.SERVICE_PROCESS_SERVICE_DETAILS,
  },
];
export const ProductProcessingCrumbSteps = [
  {
    name: 'Product Processing',
    step: 1,
    path: FrontendRoutes.PRODUCT_PROCESSING_LIST,
  },
  {
    name: 'Product Processing -',
    step: 2,
    path: FrontendRoutes.PRODUCT_PROCESSING_TASK_LIST,
  },
  {
    name: 'species_name',
    step: 3,
    path: FrontendRoutes.PRODUCT_PROCESSING_TASK_DETAILS,
  },
  {
    name: 'processItem_name',
    step: 3,
    path: FrontendRoutes.PRODUCT_INPROGRESS_DETAILS,
  },
];

export const ProfileDetailsCrumbSteps = [
  {
    name: 'Profile Details',
    step: 1,
    path: FrontendRoutes.PROFILE_DETAILS,
  },
];

export const InvocieCrumbSteps = [
  {
    name: 'Invoice',
    step: 1,
    path: FrontendRoutes.INVOICE_LIST,
  },
  {
    name: 'Ordered Items -',
    step: 2,
    path: FrontendRoutes.INVOICE_ORDERED_ITEMS,
  },
  {
    name: 'All Invoices',
    step: 3,
    path: FrontendRoutes.ALL_INVOICES,
  },
  {
    name: 'invoice_name',
    step: 4,
    path: FrontendRoutes.INVOICE_DETAILS,
  },
];

export const DashboardCrumbSteps = [
  {
    name: 'Dashboard',
    step: 1,
    path: FrontendRoutes.DASHBOARD,
  },
];

export const createCustomerBreadCrumbs = ['Customers', 'Create New Customer'];

export const PickupCrumbSteps = [
  {
    name: 'Pick Up',
    step: 1,
    path: FrontendRoutes.ORDER_PICKUP_LIST,
  },
  {
    name: 'All Invoices',
    step: 2,
    path: FrontendRoutes.ALL_INVOICES,
  },
  {
    name: 'invoice_name',
    step: 3,
    path: FrontendRoutes.INVOICE_DETAILS,
  },
];

export const AppSettingsSteps = [
  {
    name: 'App Settings',
    step: 1,
    path: '/app-settings',
  },
  {
    name: 'Profile Details',
    step: 2,
    path: FrontendRoutes.PROFILE_DETAILS,
  },
];
export const AppSettingsAboutApplicationSteps = [
  {
    name: 'App Settings',
    step: 1,
    path: '/app-settings',
  },
  {
    name: 'About Application',
    step: 2,
    path: '/about-application',
  },
];
export const AppSettingsFAQSteps = [
  {
    name: 'App Settings',
    step: 1,
    path: '/app-settings',
  },
  {
    name: 'Help/FAQ',
    step: 2,
    path: '/faq',
  },
];
export const AppSettingsSubscriptionSteps = [
  {
    name: 'App Settings',
    step: 1,
    path: '/app-settings',
  },
  {
    name: 'Subscription',
    step: 2,
    path: '/subscription/details',
  },
  {
    name: 'Billing Details',
    step: 3,
    path: '/subscription/details/billing',
  },
  {
    name: 'Invoice Details',
    step: 3,
    path: '/subscription/details/billing/invoice',
  },
];

export const orderStepper = [
  { name: 'Check-in', step: 1, path: FrontendRoutes.CREATE_ORDER_CHECKIN },
  { name: 'Service', step: 2, path: FrontendRoutes.CREATE_ORDER_SERVICE },
  { name: 'Products', step: 3, path: FrontendRoutes.CREATE_ORDER_PRODUCT },
  {
    name: 'Products Detail',
    step: 4,
    path: FrontendRoutes.CREATE_ORDER_PRODUCT_DETAILS,
  },
  { name: 'Packaging', step: 5, path: FrontendRoutes.CREATE_ORDER_PACKAGING },
  {
    name: 'Summary',
    step: 6,
    path: FrontendRoutes.CREATE_ORDER_SPECIES_SELECTION,
  },
];

//this needs to be refactored.
export const CUSTOMER_ID = 'customerId';
export const ORDERDATA = 'orderData';
export const CURRENT_CUSTOMIZING_ID = 'currentCustomizingId';
export const SPECIES_DATA = 'speciesData';
export const CUSTOMER_DETAILS = 'customerDetails';
export const BUTCHER_DETAILS = 'butcherDetails';

export const OrderCreationMasterData = {
  SPECIES_MASTER_DATA: 1,
  SERVICE_MASTER_DATA: 3,
  PRODUCT_MASTER_DATA: 4,
  ADDONS_MASTER_DATA: 5,
  PACKAGE_MASTER_DATA: 6,
  ORDER_ESTIMATION_DATE: 7,
};

export const OrderProcessingMasterData = {
  ALL_ORDER: 1,
  SETTINGS: 2,
  SERVICE_PROCESSING: 3,
  PRODUCT_PROCESSING: 4,
  INVOICE: 5,
  PICKUP: 6,
  PROFILE_DETAILS: 7,
  MY_STORE_SETTINGS: 100, // Added arbitrary values manually since this module doesn't exist in the backend
  SPECIES_AND_PRODUCT_SETUP: 101, // Same as MY_STORE_SETTINGS
  DASHBOARD: 103,
  APP_SETTINGS: 102,
};

export interface OrderSideNavProps {
  active: number;
}
export const OrderProcessingStepper = [
  'New Order',
  'Order Processing',
  'Pick up',
];
export const ServiceProcessingExistingCustomerCrumbSteps = [
  {
    name: 'Service Processing',
    step: 1,
    path: FrontendRoutes.SERVICE_PROCESSING_LIST,
  },
  {
    name: 'Existing Customers',
    step: 2,
    path: FrontendRoutes.CUSTOMER_LIST,
  },
];

export const OrderProcessStatus = {
  INITIAL: 0,
  INPROGRESS: 1,
  COMPLETED: 2,
};

export const StatusBadgeStyles = {
  blue: {
    textColor: 'text-badge-blue',
    bgColor: 'bg-badge-blue-bg',
    borderColor: 'border-badge-blue',
  },
  brown: {
    textColor: 'text-badge-brown',
    bgColor: 'bg-badge-brown-bg',
    borderColor: 'border-badge-brown',
  },
  green: {
    textColor: 'text-badge-green',
    bgColor: 'bg-badge-green-bg',
    borderColor: 'border-badge-green',
  },
  cyan: {
    textColor: 'text-badge-cyan',
    bgColor: 'bg-badge-cyan-bg',
    borderColor: 'border-badge-cyan',
  },
};

export const PickUpSettingsList = {
  OrderIsReadyWithLateFeeTemplates: '1',
  LateFeeAppliedTemplates: '2',
  OrderIsReadyTemplates: '3',
};
export const OrderStatus = {
  draft: 'Draft',
  started: 'Started',
  newOrder: 'New',
  inProgress: 'In Progress',
  partialReady: 'Partially Ready',
  partialInvoiced: 'Partially Invoiced',
  partialPaid: 'Partially Paid',
  complete: 'Complete',
  invoiced: 'Invoiced',
  paid: 'Paid',
  pickedUp: 'Picked Up',
};

export const orderProcessingStatusFilters = {
  orderStatus: [
    { label: 'In Progress', value: 1 },
    { label: 'Partially Ready', value: 2 },
    { label: 'Partially Invoiced', value: 3 },
    { label: 'Partially Paid', value: 4 },
    { label: 'Complete', value: 5 },
    { label: 'Final Invoice', value: 6 },
    { label: 'Paid', value: 7 },
  ],
  serviceOrderStatus: [
    { label: 'New', value: 0 },
    { label: 'Started', value: 1 },
    { label: 'Completed', value: 2 },
  ],
  productOrderStatus: [
    { label: 'New', value: 0 },
    { label: 'Started', value: 1 },
    { label: 'Completed', value: 2 },
  ],
  invoiceStatus: [
    { label: 'Ready to Invoice', value: 3 },
    { label: 'Partially Pick Up Ready', value: 4 },
    { label: 'Partially Packed Up', value: 5 },
    { label: 'Pick Up Ready', value: 6 },
    { label: 'Picked Up', value: 7 },
  ],
  pickupStatus: [
    { label: 'Partially Pick Up Ready', value: 4 },
    { label: 'Partially Picked Up', value: 5 },
    { label: 'Pick Up Ready', value: 6 },
    { label: 'Picked Up', value: 7 },
  ],
} as const;

export const invoiceStatuses = {
  INVOICED: 1,
  PAID: 2,
  PICKEDUP: 3,
} as const;

export const invoiceStatusLabels: Record<number, string> = {
  [invoiceStatuses.INVOICED]: 'Invoiced',
  [invoiceStatuses.PAID]: 'Paid',
  [invoiceStatuses.PICKEDUP]: 'Picked Up',
};

export const newOrderStatuses = {
  NEW: 0,
  STARTED: 1,
  PROCESSING: 2,
  READY_TO_INVOICE: 3,
  PARTIALLY_PICK_UP_READY: 4,
  PARTIALLY_PICKED_UP: 5,
  PICK_UP_READY: 6,
  PICKED_UP: 7,
} as const;

export const newOrderStatusLabels: Record<number, string> = {
  [newOrderStatuses.NEW]: 'New',
  [newOrderStatuses.STARTED]: 'Started',
  [newOrderStatuses.PROCESSING]: 'Processing',
  [newOrderStatuses.READY_TO_INVOICE]: 'Ready to Invoice',
  [newOrderStatuses.PARTIALLY_PICK_UP_READY]: 'Partially Pick up Ready',
  [newOrderStatuses.PARTIALLY_PICKED_UP]: 'Partially Picked Up',
  [newOrderStatuses.PICK_UP_READY]: 'Pick Up Ready',
  [newOrderStatuses.PICKED_UP]: 'Picked Up',
};

export const newOrderProcessingStatusFilters = {
  orderStatus: Object.entries(newOrderStatusLabels).map(([value, label]) => ({
    label,
    value: Number(value),
  })),
} as const;

export const orderListProductStatuses = {
  NEW: 0,
  PROCESSING: 1,
  COMPLETED: 2,
} as const;

export const orderListProductStatusLabels: Record<number, string> = {
  [orderListProductStatuses.NEW]: 'New',
  [orderListProductStatuses.PROCESSING]: 'Processing',
  [orderListProductStatuses.COMPLETED]: 'Completed',
};

export const orderListServiceStatuses = {
  NEW: 0,
  STARTED: 1,
  PARTIALLY_COMPLETE: 2,
  COMPLETED: 3,
} as const;

export const orderListServiceStatusLabels: Record<number, string> = {
  [orderListServiceStatuses.NEW]: 'New',
  [orderListServiceStatuses.STARTED]: 'Started',
  [orderListServiceStatuses.PARTIALLY_COMPLETE]: 'Partially complete',
  [orderListServiceStatuses.COMPLETED]: 'Completed',
};

export const productStatuses = {
  NEW: 0,
  IN_PROGRESS: 1,
  COMPLETE: 2,
  INVOICED: 3,
  PAID: 4,
} as const;

export const productStatusLabels: Record<number, string> = {
  [productStatuses.NEW]: 'New',
  [productStatuses.IN_PROGRESS]: 'In Progress',
  [productStatuses.COMPLETE]: 'Complete',
  [productStatuses.INVOICED]: 'Invoiced',
  [productStatuses.PAID]: 'Paid',
};

export const serviceStatuses = {
  NEW: 0,
  IN_PROGRESS: 1,
  COMPLETE: 2,
  INVOICED: 3,
  PAID: 4,
} as const;

export const serviceStatusLabels: Record<number, string> = {
  [serviceStatuses.NEW]: 'New',
  [serviceStatuses.IN_PROGRESS]: 'In Progress',
  [serviceStatuses.COMPLETE]: 'Complete',
  [serviceStatuses.INVOICED]: 'Invoiced',
  [serviceStatuses.PAID]: 'Paid',
};

export const orderListStatusNoneLabel = 'None';

export const ColorVariants = {
  light: {
    yellow: '#FFF0CC',
    purple: '#F2D8F3',
    blue: '#DEE7FF',
    red: '#FDD9D7',
    green: '#D5F5E3',
    lavender: '#E8DAEF',
    gold: '#FCF3CF',
    skyBlue: '#D6EAF8',
    coral: '#FADBD8',
    apricot: '#FDEBD0',
    babyBlue: '#EBF5FB',
    pastelYellow: '#FEF9E7',
    softRose: '#F9EBEA',
    steelBlue: '#EAF2F8',
  },
  dark: {
    yellow: '#E6A200',
    purple: '#AB35AF',
    blue: '#5279E4',
    red: '#DC3C30',
    green: '#2ECC71',
    lavender: '#8E44AD',
    gold: '#F1C40F',
    skyBlue: '#3498DB',
    coral: '#E74C3C',
    apricot: '#E67E22',
    babyBlue: '#5DADE2',
    pastelYellow: '#F39C12',
    softRose: '#C0392B',
    steelBlue: '#2980B9',
  },
};

export const CustomerModules = {
  DASHBOARD: 1,
  SETTINGS: 2,
  CUSTOMERS: 3,
  NEW_ORDER: 4,
  ALL_ORDERS: 5,
  SERVICE_PROCESSOR: 6,
  PRODUCT_PROCESSOR: 7,
  INVOICE_PROCESSOR: 8,
  PACKAGING_ORDER: 9,
};

export const onboardingStepId = {
  LOGO: 1,
  ADDRESS: 2,
  TAX_RATE: 3,
  SPECIES: 4,
  SERVICES: 5,
  COLOR: 6,
  SPECIES_AND_SERVICE: 7,
  PRODUCTS: 8,
  ADD_ON: 9,
  PACKAGE_TYPE: 10,
  STORAGE_COST: 11,
  ROLE_MANAGEMENT: 12,
  USER_ROLE_MANAGEMENT: 13,
  OPERATION: 14,
};

export const ProductType = {
  WEIGHT: 1,
  QUANTITY: 2,
};

export const WeightType = {
  LBS: 'Lbs',
  QUANTITY: 'Qty',
};

export const PdfType = {
  DOWNLOAD: 1,
};

export const Length = {
  FEET: 'feet',
  INCHES: 'inches',
};

// Configuration map used for duplicate validation across different form types.
export const ValidationDataSet: {
  [K in keyof DuplicateValidationFormMap]: {
    arrayKey: string; // API response key containing the array of existing records
    primarySearchField: keyof DuplicateValidationFormMap[K]; // User-entered field checked for duplicates
    SecondarySearchField?: (keyof DuplicateValidationFormMap[K])[]; // Additional fields for package size
  };
} = {
  service: {
    arrayKey: 'services',
    primarySearchField: 'name',
  },
  packagingType: {
    arrayKey: 'packageType',
    primarySearchField: 'packageType',
    SecondarySearchField: ['packageSizeId'],
  },
  addons: {
    arrayKey: 'addOns',
    primarySearchField: 'name',
  },
  colors: {
    arrayKey: 'colors',
    primarySearchField: 'color',
  },
};

// Allowed routes for the inactive(no plans) users
export const SubscriptionFreeRoutes = [
  FrontendRoutes.VIEW_PLANS,
  FrontendRoutes.VIEW_PLAN_DETAILS,
  FrontendRoutes.SUBSCRIPTION_CONFIRMATION,
  FrontendRoutes.SUBSCRIPTION_FAILED,
];

export const SubscriptionToastExcludedRoutes = [
  // App settings
  FrontendRoutes.PROFILE_DETAILS,
  FrontendRoutes.APP_SETTINGS,
  FrontendRoutes.HELP_FAQ,
  FrontendRoutes.ABOUT_APPLICATION,
  FrontendRoutes.VIEW_PLANS,
  FrontendRoutes.VIEW_PLAN_DETAILS,
  FrontendRoutes.NOTIFICATION,

  // Subscription Modules
  FrontendRoutes.SUBSCRIPTION_DETAILS,
  FrontendRoutes.SUBSCRIPTION_BILLING_DETAILS,
  FrontendRoutes.SUBSCRIPTION_BILLING_INVOICE_DETAILS,
  FrontendRoutes.SUBSCRIPTION_REACTIVATE,
  FrontendRoutes.SUBSCRIPTION_REACTIVATE_PLANS_DETAILS,
  FrontendRoutes.SUBSCRIPTION_REACTIVATE_SUCCESS,
  FrontendRoutes.SUBSCRIPTION_CONFIRMATION,
  FrontendRoutes.SUBSCRIPTION_FAILED,
  FrontendRoutes.PAYMENT_METHOD_UPDATE_SUCCESS,
  FrontendRoutes.PAYMENT_METHOD_UPDATE_FAILED,
];

export const butcherSubscriptionsStatus = {
  PENDING: 0,
  TRIAL: 1,
  ACTIVE: 2,
  GRACE_PERIOD: 3,
  SUSPENDED: 4,
  CANCELLED: 5,
};

export const ContactUsIssueOptions = [
  {
    option: 'Cancel / change subscription',
    value: 'Cancel / change subscription',
  },
  {
    option: 'Subscription not activating',
    value: 'Subscription not activating',
  },
  {
    option: 'Wrong charge / overcharged',
    value: 'Wrong charge / overcharged',
  },
  {
    option: 'Login / account access issues',
    value: 'Login / account access issues',
  },
  {
    option: 'App crashing / not loading',
    value: 'App crashing / not loading',
  },
  { option: 'App features not working', value: 'App features not working' },
  { option: 'Password reset issues', value: 'Password reset issues' },
  { option: 'Feedback / suggestion', value: 'Feedback / suggestion' },
  {
    option: 'Compliance / legal concern',
    value: 'Compliance / legal concern',
  },
  { option: 'Other', value: 'Other' },
];
